/**
 * Registry of micro-tours — small, task-specific Joyride walkthroughs
 * that the AI assistant can trigger.
 */

import type { Step } from 'react-joyride'

export interface MicroTourStep extends Step {
  page: string
}

export const microTours: Record<string, MicroTourStep[]> = {
  'create-task': [
    {
      target: '[data-tour="dashboard-create-btn"]',
      title: 'Quick Create',
      content:
        'Click this button to start creating a new task, member, or care reason.',
      placement: 'bottom',
      skipBeacon: true,
      page: '/dashboard',
    },
    {
      target: '[data-tour="sidebar-tasks"]',
      title: 'Tasks Page',
      content:
        'Or go to the Tasks page where you can see all tasks and create new ones.',
      placement: 'right',
      skipBeacon: true,
      page: '/dashboard',
    },
    {
      target: '[data-tour="tasks-create-btn"]',
      title: 'Create a Task',
      content:
        'Click here to create a new care task — set the title, assign a member, pick an interaction type, and choose a due date.',
      placement: 'bottom',
      skipBeacon: true,
      page: '/tasks',
    },
  ],

  'create-member': [
    {
      target: '[data-tour="sidebar-members"]',
      title: 'Members Section',
      content: 'Head to the Members page to manage your church directory.',
      placement: 'right',
      skipBeacon: true,
      page: '/dashboard',
    },
    {
      target: '[data-tour="members-create-btn"]',
      title: 'Add a Member',
      content:
        'Click here to add a new church member. You can enter their name, email, phone, and other details.',
      placement: 'bottom',
      skipBeacon: true,
      page: '/members',
    },
    {
      target: '[data-tour="members-search"]',
      title: 'Search Members',
      content:
        'Use the search bar to quickly find existing members by name, email, or phone.',
      placement: 'bottom',
      skipBeacon: true,
      page: '/members',
    },
  ],

  'use-filters': [
    {
      target: '[data-tour="tasks-filter-bar"]',
      title: 'Filter Bar',
      content:
        'Use these filters to narrow down your tasks by status, assignee, date range, group, and more.',
      placement: 'bottom',
      skipBeacon: true,
      page: '/tasks',
    },
    {
      target: '[data-tour="tasks-table"]',
      title: 'Filtered Results',
      content:
        'The task list updates instantly as you apply filters. Click any row to see full details.',
      placement: 'top',
      skipBeacon: true,
      page: '/tasks',
    },
  ],
}
